import { useEffect, useState } from 'react';

export function useInstallPWA() {
  const [prompt, setPrompt] = useState<any>(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Ya está instalada como PWA
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsStandalone(true);
      return;
    }

    // iOS real: Safari sin Chrome ni Chromium ni CriOS
    const ios =
      /iphone|ipad|ipod/i.test(navigator.userAgent) &&
      !/chrome/i.test(navigator.userAgent) &&
      !/chromium/i.test(navigator.userAgent) &&
      !/crios/i.test(navigator.userAgent);

    if (ios) setIsIOS(true);

    // Android/Chrome: captura el evento nativo
    const handler = (e: any) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setPrompt(null);
  };

  // Solo mostrar si no está instalada y hay prompt (Android) o es iOS en Safari real
  const canShow = !isStandalone && (!!prompt || isIOS);

  return { canShow, isIOS, install };
}
